import apiPath from '../../../config/api';

const LossesPath = {
    title: "Permata - Modul Kerugian",
    basePath: "/permata/kerugian",
    newPath: "/permata/kerugian/baru",
    detailPath: "/permata/kerugian/opsi/:id",
    base: apiPath.retailLosses,
    gnsFind: apiPath.masterGnsFind,
    gnsNmFilter: apiPath.masterGnsNmFilter,
    gnsCodeFilter: apiPath.masterGnsCodeFilter,
    gns: apiPath.masterGns,
    unitFilter: apiPath.masterUnitFilter,
    unit: apiPath.masterUnit
}

export default LossesPath;
